import { ClaimPropertyStatusEnum } from '../../../../../enums/claim-property-status.enum';
import { ClaimProductTypeEnum } from '../../../enums/ClaimProductType.enum';
import { OtherProductClaimInitialValuesType } from './types';

export const getOtherProductClaimInitialValues = (
  productType: ClaimProductTypeEnum
): OtherProductClaimInitialValuesType => ({
  productType,
  claimEstate: {
    status: 'CREATED',
    observations: '',
    responsibleId: null,
    estateResponsibleId: null,
    estateId: '',
    insurerId: '',
    createdBy: '',
    policyNumber: null,
    processNumber: null,
    claimCode: null,
    notificationEmails: [''],
    propertyPublicId: undefined,
    productType,
    eventDate: null,
    eventTime: '',
    eventDescription: ''
  },
  claimProperty: {
    zipCode: '',
    country: 'Brasil',
    city: '',
    complement: '',
    district: '',
    number: '',
    state: '',
    propertyCode: '',
    status: ClaimPropertyStatusEnum.occupied,
    street: '',
    deliveryKeysDate: undefined
  },
  claimTenant: {
    document: '',
    fullName: '',
    email: '',
    cellphone: ''
  },
  claimFiles: []
});
